import { render } from "./ResolvedDeviations.vue?vue&type=template&id=38d3a69a&scoped=true"
import script from "./ResolvedDeviations.vue?vue&type=script&lang=js"
export * from "./ResolvedDeviations.vue?vue&type=script&lang=js"

import "./ResolvedDeviations.vue?vue&type=style&index=0&id=38d3a69a&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d3a69a"]])

export default __exports__